import React from 'react';

const SafetyDeal = () => {
    return (
        <section class="bs">
        <div class="container">
          <div class="row">
            <div class="col-lg-12">
              <div class="bs__kr d-flex">
                <div class="bs-kr__text">
                  <div class="bs-kr__title">
                    Как работает Безопасная Сделка
                  </div>
                  <div class="bs-kr__subtitle">
                    Безопасная сделка — автоматизированный процесс проведения
                    сделки покупки-продажи сообщества, который гарантирует
                    выполнение обязательств и снижает риски мошенничества и
                    подлога
                  </div>
                </div>
                <div class="bs-kr__img">
                  <img src="img/security.png" alt="img" />
                </div>
              </div>
              <div class="bs-create">
                <div class="bs-create__title">
                  Как создать безопасную сделку
                </div>
                <div class="bs-create__items d-flex">
                  <div class="bs-create-item">
                    <div class="bs-create-item__title">
                      Нажмите на кнопку «Купить»
                    </div>
                    <div class="bs-creater-item__img b1">
                      <img src="img/bsimg.png" alt="img" />
                      <div class="bs-creater-item__str">
                        <img src="img/bspict.png" alt="img" />
                      </div>
                    </div>
                  </div>
                  <div class="bs-create-item">
                    <div class="bs-create-item__title b3">
                      Отправьте преложение
                    </div>
                    <div class="bs-creater-item__img b2">
                      <img src="img/bsimg2.png" alt="img" />
                    </div>
                  </div>
                </div>
              </div>
              <div class="bs-line"></div>
              <div class="bs-etap">
                <div class="bs-etap__title">
                  Этапы сделки
                </div>
                <div class="bs-etap__subtitle">
                  Безопасная сделка проводится в несколько этапов, на каждом из
                  которых для обоих участников сделки есть подсказки. Рекомендуем
                  внимательно прочитать подсказку перед совершением каждого
                  действия
                </div>
                <div class="bs-etap__items">
                  <div class="bs-etap-item d-flex">
                    <div class="bs-etap-item__img">
                      <img src="img/himal.png" alt="img" />
                    </div>
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        Согласование условий сделки
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            1 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          Участники сделки договариваются об условиях передачи
                          сообщества/аккаунта и сумме сделки, а также о других
                          деталях, если они есть
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bs-etap-item d-flex nb">
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        Резервирование денег
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            2 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          Покупатель резервирует денежные средства в системе. Пока
                          деньги не зарезервированы, продавец не должен передавать
                          доступы или данные для доступов покупателю.
                        </div>
                      </div>
                    </div>
                    <div class="bs-etap-item__img">
                      <img src="img/money.png" alt="img" />
                    </div>
                  </div>
                  <div class="bs-etap-item d-flex">
                    <div class="bs-etap-item__img">
                      <img src="img/around.png" alt="img" />
                    </div>
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        Передача прав
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            3 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          Продавец передает права, например передача прав
                          владельца VK, TG, OK или передает доступы к Instragram.
                          После получения прав или доступов, покупатель
                          ВНИМАТЕЛЬНО все проверяет, меняет и подтверждает
                          получение прав.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bs-etap-item d-flex nb">
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        На рассмотрении арбитражем
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            4 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          Если в процессе проведения сделки, одним из участников
                          нарушаются условия и договоренности, другой участник
                          может вызвать арбитра для решения ситуации. Это не
                          критическая инстанция и если в процессе обсуждения с
                          арбитром, стороны придут к соглашению, арбитраж может
                          быть отменен и сделка продолжится в обычном режиме.
                        </div>
                      </div>
                    </div>
                    <div class="bs-etap-item__img">
                      <img src="img/vesu.png" alt="img" />
                    </div>
                  </div>
                  <div class="bs-etap-item d-flex">
                    <div class="bs-etap-item__img">
                      <img src="img/tkm.png" alt="img" />
                    </div>
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        Получение денег
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            5 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          На этом этапе сделка для покупателя уже завершена.
                          Покупатель может оставить отзыв о продавце для его
                          рейтинга, а также о сервисе. Продавец выбирает удобный
                          для него способ вывода денежных средств и получает их
                          согласно условиям проведения сделки.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="bs-etap-item d-flex nb">
                    <div class="bs-etap-item__text">
                      <div class="bs-etap-item-text__title">
                        Завершено
                      </div>
                      <div class="bs-etap-item-text__content d-flex">
                        <div class="bs-etap-item-text-contentfs d-flex">
                          <div class="text">
                            6 ЭТАП
                          </div>
                        </div>
                        <div class="bs-etap-item-text__subtitle">
                          На этом этапе сделка для продавца завершена. Не забудьте
                          оставить отзыв о сервисе, это поможет нам улучшать
                          сервис и развиваться быстрее!
                        </div>
                      </div>
                    </div>
                    <div class="bs-etap-item__img">
                      <img src="img/like.png" alt="img" />
                    </div>
                  </div>
                </div>
                <div class="bs__more">
                  <a href="#">Прочитать подробные правила работы сервиса</a>
                </div>
                <div class="bs-line"></div>
                <div class="bs-secur">
                  <div class="bs-secur__items d-flex">
                    <div class="bs-secur__text">
                      <div class="bs-etap-item-text__title">
                        Период защиты сделки
                      </div>
                      <p class="bs-secur-text__subtitle">
                        Период защиты сделки составляет 1 день с момента передачи
                        прав, если в условиях сделки не указан иной срок (при
                        передаче прав владельца сообщества ВКонтакте, период
                        защиты 15 дней).
                      </p>
                      <p class="bs-secur-text__subtitle">
                        Если в течении периода защиты сделки Покупатель не
                        осуществил действия «Доступы получил» или «Вызвать
                        арбитраж», сделка считается завершенной, деньги
                        переводяться продавцу.
                      </p>
                    </div>
                    <div class="bs-secur__img">
                      <img src="img/secur.png" alt="img" />
                    </div>
                  </div>
                  <div class="bs-btn">
                    <a href="#">
                      НАПИСАТЬ АДМИНИСТРАТОРУ
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    );
}

export default SafetyDeal;
